import { Box, Grid, useMediaQuery, useTheme } from '@mui/material';

import { FBoxContainer } from '../../../../../../../components/baseV2';
import { QuestionnaireSectionLabel } from '../../../../../common';
import { FormAutocompleteField, FormDateField, FormTextField } from '../../../../../../common';
import { disabledFutureDate } from '../../../../../../../helpers';
import { US_STATE_OPTIONS } from '../../../../../../../constants';
import { REFERRAL_FIELD_PLACEHOLDERS } from '../constants';

import type { CurrentReferralSectionProps } from './types';
import { FORTA_BLUE } from '../../../../../../../utils/colors';

export default function CurrentReferralSection({
  formik,
  disabled,
  saveFieldOnBlur,
  children,
}: CurrentReferralSectionProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const referralFields = (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <FormTextField
            disabled={disabled}
            formik={formik}
            label="Referral physician name"
            name="referral_physician_name"
            onBlur={saveFieldOnBlur}
            placeholder={REFERRAL_FIELD_PLACEHOLDERS.referral_physician_name}
            required
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormDateField
            disabled={disabled}
            disabledDate={disabledFutureDate}
            formik={formik}
            label="Diagnosis date"
            name="diagnosis_date"
            onChange={saveFieldOnBlur}
            placeholder={REFERRAL_FIELD_PLACEHOLDERS.diagnosis_date}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <FormTextField
            disabled={disabled}
            formik={formik}
            label="Diagnosis city"
            name="diagnosis_city"
            onBlur={saveFieldOnBlur}
            placeholder={REFERRAL_FIELD_PLACEHOLDERS.diagnosis_city}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <FormAutocompleteField
            disabled={disabled}
            formik={formik}
            label="Diagnosis state"
            name="diagnosis_state"
            onChange={saveFieldOnBlur}
            options={US_STATE_OPTIONS}
            placeholder={REFERRAL_FIELD_PLACEHOLDERS.diagnosis_state}
            required
          />
        </Grid>
      </Grid>
      {children ? <Box mt={3}>{children}</Box> : null}
    </>
  );

  return (
    <>
      <QuestionnaireSectionLabel variant="h5" sx={{ mb: 1.5, color: FORTA_BLUE.primary }}>
        Current ASD referral
      </QuestionnaireSectionLabel>
      {isMobile ? referralFields : <FBoxContainer>{referralFields}</FBoxContainer>}
    </>
  );
}
